export default function offerCompareOptionsResolver({ offer, itemSettings, offerSettings, on }) {
    return {
        bind: {
            offer,
            settings: itemSettings,
            compareSettings: offerSettings.compare,
        },
        on: {
            'add-to-compare-click': on.addToCompareClick,
            'remove-from-compare-click': on.removeFromCompareClick,
        },
    };
}
